<template>
  <div
    class="guide-wrapper"
  >
    <div
      :class="{'guide-view-area': true, hide: step.tooltip.hideViewArea}"
      :style="viewAreaStyle"
      ref="viewArea"
    >
    </div>
    <div
      :class="getTooltipClassList()"
      :style="tooltipStyle"
      ref="tooltip"
    >
      <div
        v-if="!step.tooltip.hideArrow"
        class="arrow"
        :style="getStyle4Arrow()"
      >
      </div>
      <div
        v-if="currentScenarioId !== 0"
        class="guide-close"
        @click="$root.$emit(EVENT_SET_SCENARIO, {value: 0})"
      >
        &#215;
      </div>
      <div class="guide-assistant">
        <div class="assistant-img">
          <img
            :src="speaker.img"
            alt="Speaker image"
          >
        </div>
        <div class="assistant-title">
          <b>{{ speaker.name }}</b><br>
          {{ speaker.title }}
        </div>
      </div>
      <div
        class="guide-text"
        v-html="step.tooltip.text"
      >
      </div>
      <div :class="{'bottom-cont': true, 'last-step': totalSteps === currentStep + 1}">
        <div
          v-if="step.tooltip.showSteps"
          class="guide-steps"
        >
          {{ currentStep + 1 }} {{ texts.steps }} {{ totalSteps }}
        </div>
        <div v-if="developMode">
          <div
            v-if="currentScenarioId !== 0"
            class="guide-actions buttons-small"
          >
            <div
              v-for="(action, index) in step.tooltip.actions"
              :key="index"
            >
              <button
                class="btn btn-bordered-blue"
                :id="action.id"
                @click="trigger(action.events)"
              >
                {{ action.text }}
              </button>
            </div>
          </div>
          <div
            v-else
            class="guide-actions"
          >
            <div
              v-for="(action, index) in step.tooltip.actions"
              :key="index"
            >
              <span
                :class="{'dropdown-title' : action.subactions}"
                :id="action.id"
                @click="(action.subactions) ? dropdown() : trigger(action.events)"
              >
                {{ action.text }}
              </span>
              <ul :class="{'scenarios-dropdown': true, 'open': dropdownState}">
                <li
                  v-for="(action, index) in action.subactions"
                  :key="index"
                >
                  <span
                    :id="action.id"
                    @click="trigger(action.events)"
                  >
                    {{ action.text }}
                  </span>
                </li>
              </ul>
            </div>
            <div
              v-if="currentStep !== 0"
              class="button-back"
            >
              <button
                class="btn btn-bordered-blue"
                @click="$root.$emit(EVENT_SET_SCENARIO, {value: 0})"
              >
                Back
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-if="currentScenarioId !== 0"
            class="guide-actions buttons-small"
          >
            <div
              v-for="(action, index) in step.tooltip.actions"
              :key="index"
            >
              <button
                class="btn btn-bordered-blue"
                :id="action.id"
                @click="trigger(action.events)"
              >
                {{ action.text }}
              </button>
            </div>
          </div>
          <div
            v-else
            class="guide-actions"
          >
            <div
              v-for="(action, index) in step.tooltip.actions"
              :key="index"
            >
              <a
                v-if="action.link"
                :href="action.link"
                :class="{'dropdown-title' : action.subactions}"
                :id="action.id"
              >
                {{ action.text }}
              </a>
              <span
                v-else
                :class="{'dropdown-title' : action.subactions, 'active': dropdownState}"
                @click="(action.subactions) ? dropdown() : trigger(action.events)"
              >
                {{ action.text }}
              </span>
              <ul :class="{'scenarios-dropdown': true, 'open': dropdownState}">
                <li
                  v-for="(action, index) in action.subactions"
                  :key="index"
                >
                  <a
                    :href="action.link"
                    :id="action.id">
                    {{ action.text }}
                  </a>
                </li>
              </ul>
            </div>
            <div
              v-if="currentStep !== 0"
              class="button-back"
            >
              <button
                class="btn btn-bordered-blue"
                @click="$root.$emit(EVENT_SET_SCENARIO, {value: 0})"
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import $ from 'jquery';

import {
  EVENT_SET_PROGRESS,
  EVENT_SET_SCENARIO,
  EVENT_LOG,
  LANGUAGE_FRENCH,
} from '@/constants';

export default {
  name: 'stepGuide',
  data() {
    return {
      viewAreaElements: [],
      tooltipElement: '',
      tooltipMargin: 30,
      tooltipStyle: {
        width: '356px',
        left: '0px',
        top: '0px',
      },
      viewAreaStyle: {
        width: '0px',
        height: '0px',
        left: '0px',
        top: '0px',
      },
      lastViewAreaStyle: {
        width: '0px',
        height: '0px',
        left: '0px',
        top: '0px',
      },
      fading: true,
      offset: {
        x: -130,
        y: 0,
      },
      unit: '%',

      EVENT_SET_SCENARIO,
    };
  },
  computed: {
    ...mapState('guide', ['currentScenario', 'currentScenarioId', 'currentStep', 'dropdownState', 'lastDropdownState']),
    ...mapState('app', ['developMode']),
    step() {
      return this.$store.getters['guide/step'];
    },
    language() {
      return this.$store.state.guide.lang;
    },
    tooltipPosition() {
      return this.step.tooltip.position || 'left';
    },
    align() {
      return ((this.step.tooltip.align) / 100) || 0.5;
    },
    alignArrow() {
      return this.step.tooltip.alignArrow || 50;
    },
    additionalOffset() {
      return this.step.tooltip.offset || 0;
    },
    totalSteps() {
      return this.$store.getters['guide/totalSteps'];
    },
    speaker() {
      return this.$store.getters['guide/speaker'];
    },
    texts() {
      return this.$store.getters['guide/texts'];
    },
  },
  watch: {
    'viewAreaStyle.top'() {
      this.scroll();
    },
    step() {
      this.init();
    },
  },
  methods: {
    init() {
      this.$store.commit('guide/setScreen');
      this.reposition();

      switch (this.currentStep) {
        case 0:
          this.$store.commit('guide/closeDropdown');
          break;
        case 1:
          this.$store.commit('guide/openDropdown');
          break;
      }
    },
    setTooltipStyle() {
      const pos = this.getTooltipPosition();
      this.tooltipStyle.left = `${pos.left}px`;
      this.tooltipStyle.top = `${pos.top}px`;

      /* Custom width */
      if (this.step.tooltip.width) {
        this.tooltipStyle.width = `${this.step.tooltip.width}px`;
      } else {
        Vue.delete(this.tooltipStyle, 'width');
      }
    },
    getTooltipClassList() {
      let langClass;
      switch (this.language) {
        case LANGUAGE_FRENCH:
          langClass = 'fr-tooltip';
          break;
        default:
          langClass = '';
      }
      return `guide-tooltip ${langClass} ${this.tooltipPosition}`;
    },
    getTooltipPosition() {
      if (!this.step) return;

      let x = 0;
      let y = 0;
      let tooltipWidth = 0;
      let tooltipHeight = 0;
      let tooltipWidthHalf = 0;
      let viewAreaHalf = 0;

      switch (this.tooltipPosition) {
        case 'left':
          x = this.step.viewArea.x + this.step.viewArea.width + this.tooltipMargin + this.additionalOffset +
            this.offset.x;
          y = this.step.viewArea.y + (this.step.viewArea.height * this.align) + this.offset.y;
          if (this.align === 0.5) {
            y -= this.tooltipElement.outerHeight() / 2;
            if(this.tooltipElement.outerHeight()==0){
              y = y-210;
            }
          }
          break;
        case 'leftTRUE':
          tooltipWidth = parseInt($(this.tooltipElement[0]).css('width'));
          x = this.step.viewArea.x - tooltipWidth - this.tooltipMargin - this.additionalOffset + this.offset.x;
          y = this.step.viewArea.y + (this.step.viewArea.height * this.align) + this.offset.y;
          if (this.align === 0.5) {
            y -= this.tooltipElement.outerHeight() / 2;
          }
          break;
        case 'bottom':
          x = this.step.viewArea.x + this.step.viewArea.width * this.align + this.offset.x;
          if (this.align === 0.5) {
            x -= this.tooltipElement.outerWidth() / 2;
          }

          y = this.step.viewArea.y + this.step.viewArea.height + this.tooltipMargin + this.additionalOffset +
            this.offset.y;
          break;
        case 'top':
          if (this.align === 0.5) {
            tooltipWidthHalf = parseInt($(this.tooltipElement[0]).css('width')) / 2;
            viewAreaHalf = this.step.viewArea.width / 2;
            x = this.step.viewArea.x + this.step.viewArea.width - viewAreaHalf - tooltipWidthHalf + this.offset.x;
          } else {
            x = this.step.viewArea.x + this.step.viewArea.width * this.align + this.offset.x;
          }

          tooltipHeight = parseInt($(this.tooltipElement[0]).css('height'));
          if(tooltipHeight==0){ tooltipHeight= 330; }
          y = this.step.viewArea.y - tooltipHeight - this.additionalOffset - this.tooltipMargin + this.offset.y;
          break;
        default:
          x = this.step.viewArea.x + this.offset.x;
          y = this.step.viewArea.y + this.offset.y;
          break;
      }

      return {
        left: x,
        top: y,
      };
    },
    getStyle4Arrow() {
      const styles = {};

      this.unit = (this.step.tooltip.fixedArrow) ? 'px' : '%';

      switch (this.tooltipPosition) {
        case 'left':
          styles.top = `${this.alignArrow}${this.unit}`;
          styles.left = '-10px';
          styles.marginTop = '-10px';
          break;
        case 'leftTRUE':
          styles.top = `${this.alignArrow}${this.unit}`;
          styles.right = '-10px';
          styles.marginTop = '-10px';
          break;
        case 'bottom':
          styles.top = '-10px';
          styles.left = `${this.alignArrow}${this.unit}`;
          styles.marginLeft = '-10px';
          break;
        case 'top':
          styles.bottom = '-10px';
          styles.left = `${this.alignArrow}${this.unit}`;
          styles.marginLeft = '-10px';
          break;
        default:
          this.$root.$emit(EVENT_LOG, { message: 'please select tooltip position', type: 1 });
          break;
      }

      return styles;
    },
    setViewAreaStyles() {
      const newStyleObject = {
        left: `${this.step.viewArea.x + this.offset.x}px`,
        top: `${this.step.viewArea.y + this.offset.y}px`,
        width: `${this.step.viewArea.width}px`,
        height: `${this.step.viewArea.height}px`,
      };

      const keys = Object.keys(newStyleObject);
      keys.forEach((key) => {
        this.viewAreaStyle[key] = newStyleObject[key];
      });
    },
    trigger(events) {
      this.$root.$emit(EVENT_LOG, { message: 'trigger' });
      let that = this;

      if (undefined !== events && Array.isArray(events)) {
        events.forEach(function (item) {
          that.$root.$emit(item.type, { value: item.value });
        });
      }
    },
    reposition() {
      this.$root.$emit(EVENT_LOG, { message: 'reposition' });
      this.setTooltipStyle();
      this.setViewAreaStyles();
      this.unfocusButtons();

      const isMainScenario = this.totalSteps < 3;
      this.$root.$emit(EVENT_SET_PROGRESS, {
        value: (this.currentStep + 1) / this.totalSteps * 100,
        active: !isMainScenario,
      });

      this.saveLastViewAreaStyle();
    },
    saveLastViewAreaStyle() {
      this.lastViewAreaStyle.top = this.viewAreaStyle.top;
      this.lastViewAreaStyle.left = this.viewAreaStyle.left;
      this.lastViewAreaStyle.width = this.viewAreaStyle.width;
      this.lastViewAreaStyle.height = this.viewAreaStyle.height;
    },
    setLastViewAreaStyle() {
      this.viewAreaStyle.top = this.lastViewAreaStyle.top;
      this.viewAreaStyle.left = this.lastViewAreaStyle.left;
      this.viewAreaStyle.width = this.lastViewAreaStyle.width;
      this.viewAreaStyle.height = this.lastViewAreaStyle.height;
    },
    scroll() {
      const tooltipPosition = this.getTooltipPosition();
      if (this.step.viewArea.scrollToView) {
        $('html, body').animate({
          scrollTop: tooltipPosition.top - 100,
        }, 600);
      }
      if (this.step.viewArea.scrollToTop) {
        $('html, body').animate({
          scrollTop: 0
        }, 600);
      }
    },
    unfocusButtons() {
      let el = document.querySelector(':focus');
      if (el) el.blur();
    },
    dropdown() {
      this.$store.commit('guide/toggleDropdown');
    },
  },
  created() {
    // Recalculate tooltip position after the tooltip appeared on a screen (send app:ready event from the page)
    document.addEventListener('app:ready', () => {
      this.$nextTick(() => {
        this.setTooltipStyle();
      });
    });
  },
  mounted() {
    this.tooltipElement = $(this.$refs.tooltip);
    this.viewAreaElements.push($(this.$refs.viewArea));
  },
  updated() {
    if (this.dropdownState !== this.lastDropdownState) {
      this.$store.commit('guide/setLastDropdownState');
    } else {
      this.$store.commit('guide/setScreen');
      if (this.step.tooltip.fading === undefined || this.step.fading) {
        this.tooltipElement.hide();
        this.tooltipElement.delay(600).fadeIn(400);
      }
    }
    this.setLastViewAreaStyle();
    this.reposition();
  },
  beforeDestroy() {
    document.removeEventListener('app:ready', () => {
      this.$nextTick(() => {
        this.setTooltipStyle();
      });
    });
  },
};
</script>

<style lang="less" scoped>
  .guide-wrapper {
    position: absolute;
    top: 0;
    left: 0;
  }

  .guide-view-area {
    position: absolute;
    left: 540px;
    top: 292px;
    width: 0;
    height: 0;
    pointer-events: none;
    border: 2px solid #da262e;
    transition: top 0.6s cubic-bezier(0.19, 1, 0.22, 1),
    left 0.6s cubic-bezier(0.19, 1, 0.22, 1),
    width 0.6s cubic-bezier(0.19, 1, 0.22, 1),
    height 0.6s cubic-bezier(0.19, 1, 0.22, 1);
    z-index: 3;

    &.hide {
      display: none;
    }
  }

  .guide-tooltip {
    position: absolute;
    top: 0;
    left: 0;
    width: 356px;
    height: auto;
    padding: 28px 38px;
    box-shadow: 0 5px 18px rgba(0, 47, 81, 0.2);
    border: 1px solid #0d70b8;
    background-color: #ffffff;
    border-radius: 4px;
    pointer-events: all;
    z-index: 5;
    display: none;

    &.fr-tooltip {
      width: 458px;
    }

    &.left {
      .arrow {
        transform: rotate(-45deg);
      }
    }

    &.bottom {
      .arrow {
        transform: rotate(45deg);
      }
    }

    &.top {
      .arrow {
        transform: rotate(-135deg);
      }
    }

    &.leftTRUE {
      .arrow {
        transform: rotate(135deg);
      }
    }

    .arrow {
      position: absolute;

      width: 18px;
      height: 18px;

      border-style: solid;
      border-color: #0d70b8;
      border-width: 1px 0 0 1px;

      background: #fff;
    }

    .guide-close {
      position: absolute;
      top: 20px;
      right: 30px;
      font-size: 18px;
      opacity: 0.5;
      transition: opacity 0.3s;
      cursor: pointer;

      &:hover {
        opacity: 1;
      }
    }

    .guide-text {
      color: #54585c;
      font-size: 14px;
      font-weight: 400;
      line-height: 26px;

      p {
        margin-bottom: 20px;
      }

    }

    .guide-assistant {
      margin-bottom: 30px;

      .assistant-img, .assistant-title {
        display: inline-block;
        vertical-align: middle;
      }

      .assistant-img {
        width: 60px;

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: block;
        }
      }

      .assistant-title {
        color: #54585c;
        font-size: 13px;
        font-weight: 400;
        line-height: 22px;
        margin-left: 15px;
      }
    }

    .bottom-cont {
      white-space: nowrap;

      .guide-steps {
        display: inline-block;
        vertical-align: middle;
        width: 50%;
        color: #90a4ae;
        font-size: 13px;
        font-weight: 400;
        line-height: 22px;
        padding-left: 1px;
        text-align: left;

        & + div {
          width: 50%;
          display: inline-block;
          vertical-align: middle;
          text-align: right;
        }
      }

      .guide-actions {
        .btn {
          background: none;
          width: 100%;
          margin: 10px auto;
          outline: none;

          &:hover, &:active, &:focus {
            background: #008cce;
          }
        }

        &.buttons-small {
          float: right;

          & > div {
            display: inline-block;
            text-align: right;
            margin-left: 15px;

            &:first-child {
              margin-left: 0;
            }
          }

          .btn {
            width: auto;
            padding: 6px 22px;
          }
        }

        a, span {
          cursor: pointer;
          color: #0d71b9;
          font-size: 14px;
          font-weight: 600;
          line-height: 24px;
          border-bottom: 1px solid rgba(13, 112, 184, 0.35);
          text-decoration: none;
          display: inline-block;
          margin: 6px 0;

          i {
            font-size: 10px;
            font-weight: 100;
          }

          &.active {
            border-bottom: none;
          }

          &:hover {
            border-bottom: 1px solid rgba(13, 112, 184, 1);
          }

          &.dropdown-title {
            border-bottom: 1px dashed rgba(13, 112, 184, 0.35);
            position: relative;

            &:hover, &.active {
              border-bottom: 1px dashed rgba(13, 112, 184, 1);
            }

            &:after {
              position: absolute;
              right: -15px;
              top: 8px;
              display: inline-block;
              font: normal normal normal 14px/1 FontAwesome;
              text-rendering: auto;
              -webkit-font-smoothing: antialiased;
              font-size: 9px;
              content: "\f078";
              transform: rotate(0deg);
              transition: transform 0.5s, top 0.5s, right 0.5s;
            }

            &.active {
              &:after {
                right: -15px;
                top: 10px;
                transform: rotate(-180deg);
              }
            }
          }

          & + .scenarios-dropdown {
            list-style: none;
            padding: 0;
            margin: 0;
            max-height: 0;
            position: relative;
            overflow: hidden;
            transition: max-height 0.7s;

            &.open {
              max-height: 200px;
            }

            li {
              white-space: nowrap;

              a, span {
                color: #0d70b8;
                font-size: 14px;
                font-weight: 400;

              }

              &:before {
                content: "•";
                padding-right: 8px;
                margin-right: 18px;
              }
            }
          }
        }

        .button-back {
          button {
            width: auto;
            padding: 6px 32px;
          }
        }
      }

      &.last-step {
        white-space: normal;

        .guide-steps {
          width: 100%;

          & + div {
            width: 100%;
            text-align: left;
          }
        }

        .buttons-small {
          float: none;
        }
      }
    }
  }
</style>
